import React, { useState, useEffect, useRef } from "react";
import styles from "./ProjectExclusionSetting.module.css";
import DynamicTable from "@atlaskit/dynamic-table";
import Modal, {
  ModalBody,
  ModalFooter,
  ModalHeader,
  ModalTitle,
  ModalTransition,
} from "@atlaskit/modal-dialog";
import Button from "@atlaskit/button";
import {
  TableWrapper,
  createCells,
  createHead,
} from "../../components/ProjectExclusion/Table/ProjectExclusionTable";
import { API } from "../../utility/Api";
import { UseToast } from "../../components/context/ToastContext";
import SearchIcon from "@atlaskit/icon/glyph/search";
import CrossCircleIcon from "@atlaskit/icon/glyph/cross-circle";
import Textfield from "@atlaskit/textfield";
import Form, { Field } from "@atlaskit/form";
import Lozenge from "@atlaskit/lozenge";
import EditFilledIcon from "@atlaskit/icon/glyph/edit-filled";
import { errorHandler } from "../../helpers/helpers";
import CheckIcon from "@atlaskit/icon/glyph/check";
import EditorCloseIcon from "@atlaskit/icon/glyph/editor/close";
const ProjectExclusionSetting = (props) => {
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [projectList, setProjectList] = useState([]);
  const [includedCount, setIncludedCount] = useState(0);
  const [excludedCount, setExcludedCount] = useState(0);
  const [globalCheckState, setGlobalCheckState] = useState({
    allChecked: true,
    indeterminate: false,
    disabled: false,
  });
  const { setMainMessage } = UseToast();
  const [isloading, setLoading] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [checkedProjects, setCheckedProjects] = useState([]);
  const [data, setData] = useState([]);
  const [disabled, setDisabled] = useState(true);
  const validate = useRef("");
  const [respExProjCount, setRespExProjCount] = useState(0);
  const [refresh, setRefresh] = useState(false);

  const handleFinish = (excludedProjects, includedProjects) => {
    const excludeProjects = async (token) => {
      const data = {
        excludedProject: excludedProjects,
        includedProject: includedProjects,
      };
      await API.post(`/api/exclude_projects`, data, {
        headers: {
          Authorization: `JWT ${token}`,
        },
      })
        .then(function (response) {
          setMainMessage({
            text: "Settings saved successfully",
            appearance: "success",
          });
          setRefresh((prev) => !prev);
          setDisabled(true);
        })
        .catch(function (error) {
          const data = errorHandler(error);
          setMainMessage({ appearance: "error", text: data.message });
        });
    };

    // eslint-disable-next-line
    AP.context.getToken(function (token) {
      excludeProjects(token);
    });
  };

  useEffect(() => {
    const getData = async (token) => {
      setLoading(true);
      await API.get(`api/exclude_projects`, {
        headers: {
          Authorization: `JWT ${token}`,
        },
      })
        .then(function (response) {
          setProjectList(response.data.projects);
          setData(response.data.projects);
          setIncludedCount(
            response.data.projects.length - response.data.excludedProjectsCount
          );
          setRespExProjCount(response.data.excludedProjectsCount);
          setExcludedCount(response.data.excludedProjectsCount);
          setCheckedProjects(
            response.data.projects.filter((ele) => ele.isExcluded === false)
          );
          setSearchText("");
          if (
            response.data.excludedProjectsCount > 0 ||
            response.data.projects.length === 0
          ) {
            setGlobalCheckState({
              allChecked: false,
            });
          }
          setLoading(false);
        })
        .catch(function (error) {
          setMainMessage({ appearance: "error", data: error.message });
          setLoading(false);
        });
    };
    // if (projectList.length !== 0) {
    //   setLoading(true);
    //   setGlobalCheckState({
    //     indeterminate: false,
    //     allChecked: true,
    //     disabled: false,
    //   });
    // }
    //eslint-disable-next-line
    AP.context.getToken(function (token) {
      getData(token);
    });
  }, [refresh]);

  // useEffect(() => {}, [searchText]);

  const handleCheckboxCheckAll = (e) => {
    if (!e.target.checked) {
      setGlobalCheckState({
        allChecked: false,
        indeterminate: false,
        disabled: false,
      });

      if (validate.current !== "") {
        //Removing the projects deselected by the user.
        let matchList = checkedProjects;
        let newCheckedList = projectList.reduce((acc, proj) => {
          const matches = matchList.filter(
            (checkedProj) => checkedProj.projectId !== proj.projectId
          );
          matchList = matches;
          return matchList;
        }, []);
        setCheckedProjects(newCheckedList);
        setIncludedCount(newCheckedList.length);
        setExcludedCount(data.length - newCheckedList.length);
      } else {
        setCheckedProjects([]);
        setIncludedCount(0);
        setExcludedCount(data.length);
      }
    } else {
      if (validate.current !== "") {
        const checked = checkedProjects;
        projectList.map((ele) => {
          if (!checkedProjects.includes(ele)) checked.push(ele);
          return checked;
        });
        setCheckedProjects(checked);
        setGlobalCheckState({
          allChecked: true,
          indeterminate: false,
          disabled: false,
        });
        setIncludedCount(checked.length);
        setExcludedCount(data.length - checked.length);
      } else {
        setGlobalCheckState({
          allChecked: true,
          indeterminate: false,
          disabled: false,
        });
        checkedProjects.splice(0, checkedProjects.length);
        setCheckedProjects(data);
        setIncludedCount(data.length);
        setExcludedCount(0);
      }
    }
  };

  const handleCheckboxCheck = (e, row) => {
    if (e.target.checked) {
      if (checkedProjects.length === data.length - 1) {
        setGlobalCheckState({
          allChecked: true,
          indeterminate: false,
          disabled: false,
        });
      } else
        setGlobalCheckState({
          allChecked: false,
          indeterminate: true,
          disabled: false,
        });
      checkedProjects.push(row);
      setIncludedCount((prev) => prev + 1);
      if (excludedCount > 0) setExcludedCount((prev) => prev - 1);
    } else {
      let afterUncheckList = checkedProjects.filter(
        (ele) => ele.projectId !== row.projectId
      );
      setCheckedProjects(afterUncheckList);
      if (globalCheckState.allChecked)
        setGlobalCheckState({
          ...globalCheckState,
          allChecked: false,
        });
      else {
        if (checkedProjects.length === 0)
          setGlobalCheckState({
            ...globalCheckState,
            allChecked: false,
            indeterminate: false,
          });
      }
      setIncludedCount((prev) => prev - 1);
      setExcludedCount((prev) => prev + 1);
    }
  };

  const head = createHead(
    true,
    handleCheckboxCheckAll,
    isloading,
    globalCheckState,
    checkedProjects,
    data,
    disabled
  );
  const rows = createCells(
    projectList,
    handleCheckboxCheck,
    checkedProjects,
    disabled
  );

  const searchResult = (toSearch) => {
    const lowercasedValue = toSearch.toLowerCase();
    const filteredData = data.filter((el) =>
      el.projectName.toLowerCase().includes(lowercasedValue)
    );
    //check if projects in filteredData are already checkedProjects
    const bol = filteredData.every((ele) => checkedProjects.includes(ele));
    if (bol && filteredData && filteredData.length !== 0)
      setGlobalCheckState({
        allChecked: true,
        indeterminate: false,
        disabled: false,
      });
    else {
      setGlobalCheckState({
        allChecked: false,
        indeterminate: false,
        disabled: false,
      });
    }
    setProjectList(filteredData);
  };

  const getChangedProjects = () => {
    let matchList = data;
    let excludedList = [];
    if (checkedProjects.length === 0) excludedList = data;
    else {
      excludedList = checkedProjects.reduce((acc, proj) => {
        const matches = matchList.filter(
          (checkedProj) => checkedProj.projectId !== proj.projectId
        );
        matchList = matches;
        return matchList;
      }, []);
    }
    //newlyIncludedProjects will include the projects that were changed from excluded to included
    let newlyIncludedProjects = [];
    checkedProjects.forEach((ele) => {
      if (data[data.indexOf(ele)].isExcluded === true)
        newlyIncludedProjects.push(ele);
    });
    //newlyExcludedProjects will include the projects that were changed from included to excluded
    let newlyExcludedProjects = [];
    excludedList.forEach((ele) => {
      if (data[data.indexOf(ele)].isExcluded === false)
        newlyExcludedProjects.push(ele);
    });
    return { newlyExcludedProjects, newlyIncludedProjects };
  };

  const handleCancel = () => {
    setDisabled(true);
    setProjectList(data);
    setIncludedCount(data.length - respExProjCount);
    setExcludedCount(respExProjCount);
    setCheckedProjects(data.filter((ele) => ele.isExcluded === false));
    if (respExProjCount > 0 || data.length === 0) {
      setGlobalCheckState({
        allChecked: false,
      });
    }
  };

  return (
    <>
      <ModalTransition>
        {showConfirmation && (
          <Modal onClose={() => setShowConfirmation(false)}>
            <ModalHeader>
              <ModalTitle>Include/Exclude project(s)</ModalTitle>
            </ModalHeader>
            <ModalBody>
              <div>
                Selected project(s) will be backed up whereas unselected
                project(s) will be skipped from backups.
                <br />
                <br />
                Are you sure you want to proceed?
              </div>
            </ModalBody>
            <ModalFooter>
              <Button
                appearance="subtle"
                onClick={() => setShowConfirmation(false)}
              >
                Cancel
              </Button>
              <Button
                onClick={() => {
                  setDisabled(true);
                  const { newlyExcludedProjects, newlyIncludedProjects } =
                    getChangedProjects();
                  if (
                    newlyExcludedProjects.length > 0 ||
                    newlyIncludedProjects.length > 0
                  )
                    handleFinish(
                      newlyExcludedProjects.map((val) => {
                        return {
                          projectId: val.projectId,
                          projectName: val.projectName,
                        };
                      }),
                      newlyIncludedProjects.map((val) => {
                        return {
                          projectId: val.projectId,
                          projectName: val.projectName,
                        };
                      })
                    );
                  setShowConfirmation(false);
                }}
                appearance="primary"
                autoFocus
              >
                Yes
              </Button>
            </ModalFooter>
          </Modal>
        )}
      </ModalTransition>
      <div className={styles.tableContainer}>
        <div className={styles.subContainer}>
          <div className={styles.tableHead}>
            <div style={{ fontSize: "1.1rem", fontWeight: 600 }}>
              Project List({data.length})
            </div>
            {disabled ? (
              <Button
                appearance="subtle"
                iconBefore={<EditFilledIcon primaryColor="#0a59cc" />}
                onClick={() => setDisabled(false)}
              >
                &nbsp;Edit
              </Button>
            ) : (
              <div className={styles.cancelCheckButton}>
                <Button
                  appearance="primary"
                  iconBefore={<CheckIcon />}
                  onClick={() => {
                    const { newlyExcludedProjects, newlyIncludedProjects } =
                      getChangedProjects();
                    if (
                      newlyExcludedProjects.length > 0 ||
                      newlyIncludedProjects.length > 0
                    )
                      setShowConfirmation(true);
                  }}
                >
                  Save
                </Button>
                <Button
                  appearance="subtle"
                  iconBefore={<EditorCloseIcon />}
                  onClick={() => handleCancel()}
                >
                  Cancel
                </Button>
              </div>
            )}
          </div>
          <TableWrapper>
            <DynamicTable
              caption={
                <div className={styles.searchBarContainer}>
                  <Form
                    onSubmit={(data) => {
                      setSearchText(data.searchText);
                      searchResult(data.searchText);
                    }}
                    isDisabled={isloading}
                  >
                    {({ formProps }) => (
                      <form {...formProps}>
                        <div className={styles.filterItem}>
                          <Field
                            name="searchText"
                            defaultValue={searchText}
                            // validate={async (value) => {
                            //   const regexp = new RegExp("^[ A-Za-z0-9@#_-]*$");
                            //   if (regexp.test(value)) {
                            //     return undefined;
                            //   } else {
                            //     return "Please Enter Valid Search Text";
                            //   }
                            // }}
                          >
                            {({ fieldProps, error }) => (
                              <>
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "2px",
                                    width: "200px",
                                    height: "18px",
                                  }}
                                >
                                  <Textfield
                                    elemAfterInput={
                                      <div
                                        style={{
                                          paddingRight: "6px",
                                          lineHeight: "100%",
                                        }}
                                      >
                                        <SearchIcon
                                          size="small"
                                          borderColor="transparent"
                                        />
                                      </div>
                                    }
                                    placeholder="Search project"
                                    {...fieldProps}
                                    onChange={(value) => {
                                      setSearchText(value.target.value);
                                      searchResult(value.target.value);
                                      fieldProps.onChange(value);
                                      validate.current = value.target.value;
                                    }}
                                  />
                                  {searchText.length !== 0 && (
                                    <Button
                                      size="small"
                                      appearance="subtle"
                                      onClick={() => {
                                        setSearchText("");
                                        searchResult("");
                                      }}
                                    >
                                      <CrossCircleIcon
                                        size="small"
                                        borderColor="transparent"
                                      />
                                    </Button>
                                  )}
                                </div>
                              </>
                            )}
                          </Field>
                        </div>
                      </form>
                    )}
                  </Form>
                  <div className={styles.count}>
                    <div>
                      Included: &nbsp;
                      {
                        <Lozenge
                          isBold
                          style={{
                            padding: "20px",
                            backgroundColor: "#B3D4FF",
                            color: "black",
                          }}
                        >
                          {includedCount}
                        </Lozenge>
                      }
                    </div>
                    <div>
                      Excluded:&nbsp;
                      {
                        <Lozenge
                          isBold
                          style={{
                            padding: "20px",
                            backgroundColor: "#B3F5FF",
                            color: "black",
                          }}
                        >
                          {excludedCount}
                        </Lozenge>
                      }
                    </div>
                  </div>
                </div>
              }
              head={head}
              rows={rows}
              rowsPerPage={10}
              defaultPage={1}
              loadingSpinnerSize="large"
              isLoading={isloading}
              isFixedSize
              defaultSortKey="ProjectName"
              defaultSortOrder="ASC"
              emptyView={<strong>No projects found</strong>}
            />
          </TableWrapper>
        </div>
      </div>
    </>
  );
};

export default ProjectExclusionSetting;
